import Vue from 'vue'
import Axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import './plugins/element.js'
import internal from './plugins/internal'
import request from './assets/lib/request'

Vue.use(internal)
Vue.use(VueAxios, Axios)
Vue.use(request)
Vue.config.productionTip = false

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
